import React from "react";
import {
  formatSimpleDate,
  getTitleDecoration,
  formatNumber,
  getDayOfDate,
} from "utils/common";

const Card = ({ payment_result }) => {
  return (
    <div className="card-layout my-2 my-md-0 px-3 px-md-0 py-2">
      <div className="row gx-0">
        <div className="w-col-10 pe-2 pe-md-0">
          <div className="row gx-0">
            <div className="col-12 col-md-9">
              <span
                dangerouslySetInnerHTML={{
                  __html: getTitleDecoration(
                    payment_result.title_decoration?.title_decoration_content
                  ),
                }}
              ></span>
              {payment_result?.promotion_name}
            </div>
            <div className="col-12 mt-1 mt-md-0 col-md-3 text-start text-md-center date-1">
              <span className="d-inline-block d-md-none me-1">完了日 :</span>
              {formatSimpleDate(payment_result?.point_effective_date)}
              <span className="d-inline-block d-md-none">
                ({getDayOfDate(payment_result.point_effective_date)})
              </span>
            </div>
          </div>
        </div>
        <div className="w-col-2 col-border price text-center">
          {formatNumber(payment_result?.point)}
          <div className="d-block d-md-none">ポイント</div>
        </div>
      </div>
    </div>
  );
};

export default Card;
